// extracted by mini-css-extract-plugin
module.exports = {"chart-placeholder":"_2n5ks-","chartPlaceholder":"_2n5ks-","icon":"AsWNR-","small":"_73n5x-","large":"bWr3I-"};